"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CommandProductModal;
var _react = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function CommandProductModal({
  name,
  subtitle,
  description,
  imageUrl,
  images = [],
  allergens = [],
  ingredients = [],
  tags = [],
  sections = [],
  prices = [],
  addLabel = 'Ajouter',
  customizeLabel,
  onAdd,
  onCustomize,
  onClose,
  uri_transformer = url => url
}) {
  const gallery = images.length > 0 ? images : imageUrl ? [imageUrl] : [];
  const [imageIndex, setImageIndex] = (0, _react.useState)(0);
  const [quantity, setQuantity] = (0, _react.useState)(1);
  const [selectedPriceId, setSelectedPriceId] = (0, _react.useState)(prices[0]?.id ?? null);
  (0, _react.useEffect)(() => {
    const onKey = event => {
      if (event.key === 'Escape') onClose?.();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);
  const selectedPrice = prices.find(price => price.id === selectedPriceId) ?? prices[0];
  const currentImage = gallery[imageIndex] ?? null;
  const handleAdd = () => {
    if (!selectedPrice || !onAdd) return;
    onAdd(selectedPrice, quantity);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "command-kiosk__overlay command-product-modal-overlay",
    onClick: onClose,
    role: "presentation",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "command-product-modal",
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": "command-product-modal-title",
      onClick: event => event.stopPropagation(),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        type: "button",
        className: "command-product-modal__close",
        onClick: onClose,
        "aria-label": "Fermer",
        children: "\xD7"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "command-product-modal__media",
        children: [currentImage ? /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: uri_transformer(currentImage),
          alt: "",
          className: "command-product-modal__image"
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "command-product-modal__placeholder",
          children: "\uD83C\uDF7D\uFE0F"
        }), gallery.length > 1 && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "command-product-modal__thumbs",
          children: gallery.map((src, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            type: "button",
            className: `command-product-modal__thumb ${index === imageIndex ? 'command-product-modal__thumb--active' : ''}`,
            onClick: () => setImageIndex(index),
            "aria-label": `Image ${index + 1}`,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
              src: uri_transformer(src),
              alt: ""
            })
          }, src))
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "command-product-modal__body",
        children: [subtitle && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          className: "command-product-modal__subtitle",
          children: subtitle
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
          id: "command-product-modal-title",
          className: "command-product-modal__title",
          children: name
        }), description ? /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          className: "command-product-modal__desc",
          children: description
        }) : null, tags.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "command-product-modal__tags",
          children: tags.map(tag => /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: "command-product-modal__tag",
            children: tag
          }, tag))
        }), ingredients.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("section", {
          className: "command-product-modal__section",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h4", {
            children: "Ingr\xE9dients"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            children: ingredients.join(', ')
          })]
        }), allergens.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("section", {
          className: "command-product-modal__section",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h4", {
            children: "Allerg\xE8nes"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "command-product-modal__allergens",
            children: allergens.map(allergen => /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
              className: "command-product-modal__allergen",
              children: [allergen.icon ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                "aria-hidden": "true",
                children: allergen.icon
              }) : null, allergen.name]
            }, allergen.id ?? allergen.name))
          })]
        }), sections.map(section => /*#__PURE__*/(0, _jsxRuntime.jsxs)("section", {
          className: "command-product-modal__section",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h4", {
            children: section.title
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            children: section.items.join(', ')
          })]
        }, section.title)), prices.length > 1 && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "command-product-modal__prices",
          role: "radiogroup",
          "aria-label": "Prix",
          children: prices.map(price => /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
            type: "button",
            role: "radio",
            "aria-checked": price.id === selectedPrice?.id,
            className: `command-product-modal__price ${price.id === selectedPrice?.id ? 'command-product-modal__price--active' : ''}`,
            onClick: () => setSelectedPriceId(price.id),
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              children: price.label
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              children: price.formatted
            })]
          }, price.id))
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("footer", {
        className: "command-product-modal__footer",
        children: onCustomize ? /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
          type: "button",
          className: "command-product-modal__add",
          onClick: onCustomize,
          children: customizeLabel || 'Personnaliser'
        }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "command-product-modal__qty",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
              type: "button",
              onClick: () => setQuantity(qty => Math.max(1, qty - 1)),
              "aria-label": "Diminuer",
              children: "\u2212"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              children: quantity
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
              type: "button",
              onClick: () => setQuantity(qty => qty + 1),
              "aria-label": "Augmenter",
              children: "+"
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
            type: "button",
            className: "command-product-modal__add",
            onClick: handleAdd,
            disabled: !selectedPrice,
            children: [addLabel, selectedPrice ? ` · ${selectedPrice.formatted}` : '']
          })]
        })
      })]
    })
  });
}